import apiFetch from '../../apiFetch'

export default function (dossierId, body, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/dossierBudgetRating/${dossierId}`, body: body, method: 'PUT', token: token, lastAccessDate })
}
